// Site-wide safety net for product photos. Photos are served resized from a CDN (bloom-images.b-cdn.net) whose first
// hit for a picture can be slow or fail on a weak connection; a failed <img> otherwise stays blank forever.
// On error: 1) retry the CDN URL once (cache-busted), 2) fall back to the original file in storage.
const CDN = "https://bloom-images.b-cdn.net/";
const ORIGIN = "https://fjpmovyrvuuvgdhwusec.supabase.co/storage/v1/object/public/bloom-images/";

export function nextImageSrc(src, step) {
  const s = String(src || "");
  if (!s.startsWith(CDN)) return null;                       // only our CDN photos
  if (step === 0) return s + (s.includes("?") ? "&" : "?") + "r=1";
  if (step === 1) return ORIGIN + s.slice(CDN.length).split("?")[0];
  return null;
}

export function installImageFallback(win = window) {
  win.addEventListener("error", (e) => {
    const el = e.target;
    if (!el || el.tagName !== "IMG") return;
    const step = Number(el.dataset.fb || 0);
    const next = nextImageSrc(el.currentSrc || el.src, step);
    if (!next) return;
    el.dataset.fb = String(step + 1);
    setTimeout(() => { el.src = next; }, step === 0 ? 800 : 0);
  }, true);
}
